import http from './http';

export default {
  updateAddress(data) {
    return http().patch(`/v1/properties/${data.id}/address`, data);
  },
  updatePropertyInfo(data) {
    return http().patch(`/v1/properties/${data.id}/property_info`, data);
  },
  getRealEstateAPIData(recordId) {
    return http().get(`/v1/properties/${recordId}/real_estate_api_data`);
  },
  getProprtyDetailsForm(propertyId) {
    return http().get(`/v1/properties/${propertyId}/details-form`)
  },
  getRealEstateCompData(propertyId, isRefresh = false) {
    return http().post(`/v1/properties/${propertyId}/real-estate-comp-data`, {
      refresh: isRefresh
    });
  },
  updateRealEstateCompData(propertyId, data) {
    return http().put(`/v1/properties/${propertyId}/real-estate-comp-data`, data);
  },
}
